export default __webpack_public_path__ + "static/media/landing_video_data.5174dcc0.jpg";